export const SUPPORT_EMAIL = 'FastTrack-Support@lsq.com';
export const SUPPORT_PHONE = '(407) 815-2229';
